/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
import EventsEmitter from 'minivents';

export class Store {
  _seashotsList /*: string[] */ = [];
  hub /*: EventsEmitter */ = new EventsEmitter();

  get seashotsList() /*: string[] */ {
    return this._seashotsList;
  }
  set seashotsList(seashotsList /*: string[] */) {
    this._seashotsList = seashotsList;
    this.hub.emit('change');
  }
}
